import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Initialize Sentry lazily after first render so it doesn't block FCP
import("./lib/sentry").then((m) => m.initSentry());
